import { Component, OnInit } from "@angular/core";
import { AppService } from "../../../services/app.service";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { CreditNoteService } from "../credit-node-service";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { STORAGE } from "src/app/constant/storages";

@Component({
  selector: "app-credit-note-tax-list",
  templateUrl: "./credit-note-tax-list.component.html",
  styleUrls: ["./credit-note-tax-list.component.scss"],
})
export class CreditNoteTaxListComponent implements OnInit {
  creditNoteLists: any = [];
  request: any;
  response: any;
  isOldAbb: boolean = false;
  Active = 3;
  datalist: any;

  pager: any = {};
  pagedItems = [];
  count: any;

  constructor(
    public apiservice: ApiserviceService,
    public appService: AppService,
    public router: Router,
    public route: ActivatedRoute,
    public navCtrl: NavController,
    public storage: Storage,
    public appservice: AppService,
    public cnService: CreditNoteService
  ) {}

  async ngOnInit() {}
  ionViewDidEnter() {
    this.route.queryParams.subscribe((params) => {
      console.log("params.datalist=====: ", params.datalist);
      this.datalist = params.datalist;
      console.log("=====this.datalist========", this.datalist);
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });
  }

  async ionViewWillEnter() {
    window.localStorage.pageName = "CreditNoteTaxListComponent";
    this.appservice.setActive(2);
    this.isOldAbb = window.localStorage.isOldAbb == "Y" ? true : false;

    await this.getStorageData();
  }

  async getStorageData() {
    let res = _getStorage(STORAGE.searchCreditNode);
    if (this.isOldAbb) {
      if (this.datalist === "datalist") {
        const response = _getStorage(STORAGE.listdataCreditnote);
        this.creditNoteLists = response;
      } else {
        this.creditNoteLists = res.response.taxinvoice_list;
      }
    } else {
      if (this.datalist === "datalist") {
        const response = _getStorage(STORAGE.listdataCreditnote);
        this.creditNoteLists = response;
      } else {
        this.creditNoteLists = res.response.buyer_data;
      }
    }
    // this.response = res.response;
    // this.request = res.request;
    this.setPage(1);
  }

  setPage(page: number) {
    this.pager = this.appService.getPager(this.creditNoteLists.length, page);
    this.pagedItems = this.creditNoteLists.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    console.log("pager.pages===>", this.pager.pages);
  }

  goBackPage() {
    if (this.Active === 3) {
      this.router.navigate(["/credit-note"]);
    } else {
      this.router.navigate(["/credit-note"], {
        queryParams: { noName: "no_cn", selectedIndex: "4" },
      });
    }
  }
  gotocreditselect() {
    if (this.Active === 3) {
      this.router.navigate(["/credit-select-taxinvoice"]);
    } else {
      this.router.navigate(["/no-credit"], {
        queryParams: { noName: "no_cn", selectedIndex: "4" },
      });
    }
  }

  async goToDetailPage(item: any) {
    console.log("creditNoteLists ====== item:: ", item);
    let verifyData: any;

    const index = this.creditNoteLists.findIndex(
      (f) => f.buyer_id === item.buyer_id
    );
    if (index > -1) {
      if (!this.isOldAbb) {
        verifyData = await this.cnService.setTaxinvoiceList([
          this.creditNoteLists[index],
        ]);
        console.log("[goToDetailPage] verifyData : ", verifyData);
      } else {
        verifyData = this.creditNoteLists[index];
      }
    }
    console.log('verifyData========: ',verifyData)
    _setStorage(STORAGE.verifyCreditNote, verifyData);
    if (this.Active === 3) {
      this.router.navigate(["/credit-check-taxinvoice"]);
    } else {
      this.router.navigate(["/credit-check-taxinvoice"], {
        queryParams: { noName: "no_cn", selectedIndex: "4" },
      });
    }
  }

  viewBuyerDetail(item: any) {
    console.log("viewBuyerDetail =====: ", item);
    const index = this.creditNoteLists.findIndex(
      (f) => f.buyer_id === item.buyer_id
    );
    if (index > -1) {
      _setStorage(STORAGE.viewDataIndx, index);
    }
    if (this.Active === 3) {
      if (this.datalist === "datalist") {
        this.router.navigate(["/credit-select-taxinvoice"], {
          queryParams: {
            datalist: "datalist",
            updatecustomer: "updatecustomer",
          },
        });
      } else {
        this.router.navigate(["/credit-select-taxinvoice"], {
          queryParams: { updatecustomer: "updatecustomer" },
        });
      }
    } else {
      if (this.datalist === "datalist") {
        this.router.navigate(["/no-credit"], {
          queryParams: {
            noName: "no_cn",
            selectedIndex: "4",
            updatecustomer: "updatecustomer",
            datalist: "datalist",
          },
        });
      } else {
        this.router.navigate(["/no-credit"], {
          queryParams: {
            noName: "no_cn",
            selectedIndex: "4",
            updatecustomer: "updatecustomer",
          },
        });
      }
    }
  }

  checkbranch(data: any) {
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.buyer_main_branch_no === "00000") {
        return "สำนักงานใหญ่";
      } else {
        return data.buyer_branch_no;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    } else {
      return "-";
    }
  }

  checkaddress(item) {
    let dataaddr: any;
    if (item.address_detail !== undefined) {
      dataaddr =
        item.address_detail[0] === undefined ? "" : item.address_detail[0];
    } else {
      dataaddr = "";
    }

    if (item.type_addr === "1" || dataaddr.type_addr === "1") {
      return item.display_address === undefined || item.display_address === ""
        ? dataaddr.addr_info
        : item.display_address;
    } else {
      return item.display_addressEN === undefined ||
        item.display_addressEN === ""
        ? dataaddr.addr_infoEN
        : item.display_addressEN;
    }
  }
}
